import { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../context/AuthContext";
import Header from "../components/Header";

export default function Home() {
  const { t } = useTranslation();
  const { state: user } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <Box sx={{ textAlign: "center", mt: 8, px: 2 }}>
        {user ? (
          <>
            <Typography variant="h4" gutterBottom>
              {t("home.hello", { pseudo: user.users_pseudo })}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t("home.welcomeConnected")}
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h4" gutterBottom>
              {t("home.welcome")}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 560, mx: "auto" }}>
              {t("home.description")}
            </Typography>
            <Button variant="contained" onClick={() => navigate("/connexion")}>
              {t("home.loginSignupBtn")}
            </Button>
          </>
        )}
      </Box>
    </>
  );
}
